import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const FileHistorySwitch = ({
  sidebarTab,
  handleSidebarTab,
}) => {
  const intl = useIntl();

  const switchTab = () => {
    if (sidebarTab === 'history') {
      handleSidebarTab('details');
    } else {
      handleSidebarTab('history');
    }
  };

  return (
    <Button
      type="button"
      onClick={switchTab}
      className="file-detail-title file-detail-header-button"
    >
      {sidebarTab === 'history' ? (
        <>
          <i className="fal fa-eye-slash" />
          {intl.formatMessage({ defaultMessage: 'Hide file history' })}
        </>
      ) : (
        <>
          <i className="fal fa-eye" />
          {intl.formatMessage({ defaultMessage: 'View file history' })}
        </>
      )}
    </Button>
  );
};

FileHistorySwitch.propTypes = {
  sidebarTab: PropTypes.string.isRequired,
  handleSidebarTab: PropTypes.func.isRequired,
};

export default FileHistorySwitch;
